import { render, staticRenderFns } from "./fullScreen.vue?vue&type=template&id=57de8cec&"
import script from "./fullScreen.vue?vue&type=script&lang=js&"
export * from "./fullScreen.vue?vue&type=script&lang=js&"
import style0 from "./fullScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports